import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { headerScreenOptions } from "../../components/HeaderBackButton";
import AccountEditContactInformation, {
  navigationTitle as editContactInfoNavigationTitle,
} from "./EditContactInformationScreen";
import { ParamList } from "./types";

const Stack = createNativeStackNavigator<ParamList>();

export default function AccountEditContactNavigator() {
  return (
    <Stack.Navigator id="AccountEditContact" screenOptions={headerScreenOptions}>
      <Stack.Screen
        name="AccountEditContactInformation"
        component={AccountEditContactInformation}
        options={{ title: editContactInfoNavigationTitle }}
      />
    </Stack.Navigator>
  );
}
